import { FaUser } from 'react-icons/fa';

interface UserAvatarProps {
  url?: string;
  username: string;
  size?: 'sm' | 'md' | 'lg';
  badgeCount?: number;
}

export function UserAvatar({
  url,
  username,
  size = 'md',
  badgeCount = 0,
}: UserAvatarProps) {
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-14 h-14',
    lg: 'w-24 h-24',
  };

  const getBorderColorClass = (count: number) => {
    switch (count) {
      case 0:
        return 'border-gray-500/50';
      case 1:
        return 'border-emerald-500/50';
      case 2:
        return 'border-green-500/50';
      case 3:
        return 'border-lime-500/50';
      case 4:
        return 'border-yellow-500/50';
      case 5:
        return 'border-amber-500/50';
      default:
        return 'border-blue-500/50';
    }
  };

  return (
    <div className="flex-shrink-0">
      {url ? (
        <img
          src={url}
          alt={username}
          className={`${sizeClasses[size]} rounded-full border-2 transition-all duration-300 ${getBorderColorClass(badgeCount)}`}
        />
      ) : (
        <div
          className={`${sizeClasses[size]} flex items-center justify-center rounded-full border-2 bg-gray-700/50 ${getBorderColorClass(badgeCount)}`}
        >
          <FaUser className='h-6 w-6 text-gray-400' />
        </div>
      )}
    </div>
  );
}
